module.exports = __webpack_public_path__ + "static/Rubik-Regular-0f878696a3908dbe755b9240c8605b2e.woff2";